import { render, staticRenderFns } from "./ServiceRequestListItem.vue?vue&type=template&id=a2905f5c&scoped=true&"
import script from "./ServiceRequestListItem.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestListItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestListItem.vue?vue&type=style&index=0&id=a2905f5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2905f5c",
  null
  
)

export default component.exports